var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-results-res"},[_vm._v(" "+_vm._s(_vm.getSummary)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }